import { LinearProgress, TableBody, TableCell, TableRow, Typography } from "@mui/material";

interface Props {
  rows: any[];
}

export function CoursesProgressTableRow({ rows }: Props) {
  return (
    <TableBody>
      {rows?.map((row: any, index: number) => (
        <TableRow key={row.course_id ?? row.id ?? index}>
          <TableCell align="left" sx={{ minWidth: "150px" }}>
            {row.course_name ?? row.status ?? ""}
          </TableCell>

          <TableCell align="left" sx={{ minWidth: "200px" }}>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>
              {row.course_completion_percentage != null
                ? `${row.course_completion_percentage}%`
                : ""}
            </Typography>
            {/* Guarded by `!= null` above — value is a real number here.
                `?? 0` is banned (courseProgress.ts header, M1/M3): a
                fallback would be dead code AND would re-introduce a
                fabricated-0% pattern. */}
            {row.course_completion_percentage != null && (
              <LinearProgress
                variant="determinate"
                value={row.course_completion_percentage}
                sx={{
                  mt: 0.5,
                  borderRadius: 1,
                  ...(row.subject?.color
                    ? {
                        "& .MuiLinearProgress-bar": {
                          backgroundColor: row.subject.color,
                        },
                      }
                    : {}),
                }}
              />
            )}
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
